import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts"
import * as DateUtils from "../../lib/DateUtils.ts"
export {init}  
Html.registerWidget('widget/form/timetabledate-selection',{init:init})

function init(element){
  var 
    form = element.closest('form').get(0),
    timetable = FwDatas.get(form.calendarId.value),
    startHiddenInput = $(form.startDate),
    endHiddenInput = $(form.endDate),
    weekSelect = $(form.startweek),
    startSelectDay = $(form.startday),
    startSelectHour = $(form.starttime),
    endSelectDay = $(form.endday),
    endSelectHour = $(form.endtime),
    updateEndOnBeginChange = true;
  
  //if it is a CalendarBean and not a TimetableBean
  if(timetable.timetable){
    timetable = timetable.timetable
  }
  
  if(timetable.weeks.length>1){
    weekSelect.html(timetable.weeks.map(week=>`<option value=${week.index}>${week.name}</option>`).join(''))  
  }
  startSelectDay.html(timetable.weeks[0].days.map((day,index)=>`<option value=${day.index}>${day.name}</option>`).join(''))
  endSelectDay.html(timetable.weeks[0].days.map((day,index)=>`<option value=${day.index}>${day.name}</option>`).join(''))
  
  endSelectDay.on('change',function(){
    updateEndOnBeginChange = false;
  });
  endSelectHour.on('change',function(){
    updateEndOnBeginChange = false;
  });
  startSelectDay.on('change',function(){
    if(updateEndOnBeginChange){
      endSelectDay.val(startSelectDay.val());
    }
  })
  
  function updateUI(){
    var 
      startDate = startHiddenInput.dateValue(),
      endDate = endHiddenInput.dateValue();

    weekSelect.val(timetable.getWeek(startDate).index)
    startSelectDay.val(startDate.getDay()),
    startSelectHour.dateValue(startDate);
    
    endSelectHour.dateValue(endDate);
    endSelectDay.val(endDate.getDay());
    
  }
  updateUI()
 
  element.closest('form').find(':input').on('blur',function(){
    var 
      week = timetable.weeks[weekSelect?weekSelect.val()||0:0],
      startday = week.days.find(day=>day.index==startSelectDay.val()),
      startHour = startSelectHour.val(),
      endday = week.days.find(day=>day.index==endSelectDay.val()),
      endHour = endSelectHour.val(),
      startFinal = new Date(startday.value+'T'+startHour),
      endFinal = new Date(endday.value+'T'+endHour);
    
    if(this.name==='endday'||this.name==='endtime'){
      if(endFinal.getTime()!==endHiddenInput.dateValue().getTime()){
        updateEndOnBeginChange = false;  
      }
      
    }
    if(updateEndOnBeginChange && (this.name==='startday'||this.name==='starttime')){
      var delta = startFinal.getTime()-startHiddenInput.dateValue().getTime();
      endFinal.setTime(endFinal.getTime()+delta)
    }   
    if(endFinal<startFinal){
      endFinal.setDate(endFinal.getDate()+7);
    }
    startHiddenInput.dateValue(startFinal),
    endHiddenInput.dateValue(endFinal);
    
    updateUI()
  })
    
}
